import {
  DynamicLinkType,
  FlexibleBlockBrickButton,
  FlexibleBlockBrickButtonStyle,
  FlexibleBlockBrickTitle,
  FlexibleBlockProps,
  FlexibleBlockTemplateHeroImpression,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getHeroImpressionBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateHeroImpression>[] => {
  const brickButton: FlexibleBlockBrickButton = {
    ...brickCommon,
    brickType: 'button',
    brickName: 'Button',
    switchable: true,
    text: 'Impress clients with portals',
    dynamicLink: { type: DynamicLinkType.EXTERNAL, url: 'https://en.wikipedia.org/wiki/Project' },
    style: FlexibleBlockBrickButtonStyle.IMPRESSION,
  };

  const brickTitle: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Title',
    switchable: true,
    placeholder: 'Here, you can add title',
    text: 'Elevate your business today!',
    className: ['md:text-6xl', 'text-3xl'],
    theme: { text: { main: PortalTextType.HERO_TEXT } },
  };

  return [
    {
      title: 'Hero Impression',
      template: { type: 'hero-impression', view: 'basic' },
      bricks: [
        { ...brickButton, index: 0 },
        { ...brickTitle, index: 1 },
      ],
      className: ['justify-around', 'min-h-72'],
      wrapper: getWrapperProps('none'),
    },
  ];
};
